const initTabsFaqs = () => {
  const tabsContainer = document.querySelector('.faq-tabs .tabs');

  if (!tabsContainer ) { return }

  const sections = document.querySelectorAll('.collapsible-tabs');
  const existingTab = tabsContainer.querySelector('.tab--anchord');

  // Generate the tabs dynamically
  sections.forEach((section, index) => {
    const titleElement = section.querySelector('.collapsible-tabs__heading');
    const title = titleElement ? titleElement.textContent.trim() : `Tab ${index + 1}`;
    const tab = document.createElement('button');

    tab.classList.add('tab');
    tab.textContent = title;
    tab.dataset.target = section.id; // Relate the tab with the section by ID
    if (index === 0) tab.classList.add('active'); // Activate the first tab by default

    // Add event to control visibility
    tab.addEventListener('click', () => {
      // Deactivate all tabs and sections
      document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
      sections.forEach(s => s.classList.remove('active'));

      // Activate the tab and its corresponding section
      tab.classList.add('active');
      section.classList.add('active');
    });

    // Add the tab to the tabs container
    tabsContainer.appendChild(tab);
  });

  if (existingTab) {
    tabsContainer.appendChild(existingTab).classList.remove('active');
  }

  // Show the first section by default
  if (sections.length > 0) {
    sections[0].classList.add('active');
  }
}

export { initTabsFaqs }